import { Component, type ErrorInfo, type PropsWithChildren, type ReactNode } from 'react';
import { useNetworkStatus } from '../hooks/useNetworkStatus';
import { useAppStore } from '../store/AppStore';

export function SystemBanners() {
  const online = useNetworkStatus();
  const { error, clearError, reload } = useAppStore();
  return <>
    {!online && <div className="global-banner offline" role="status" aria-live="polite">오프라인 상태입니다. 모의 API에서는 로컬 기록이 유지됩니다.</div>}
    {error && <div className="global-banner error" role="alert"><span>{error}</span><button onClick={() => { clearError(); void reload(); }}>다시 시도</button></div>}
  </>;
}

export class AppErrorBoundary extends Component<PropsWithChildren, { hasError: boolean }> {
  state = { hasError: false };
  static getDerivedStateFromError() { return { hasError: true }; }
  componentDidCatch(error: Error, info: ErrorInfo) { console.error('MRM_RENDER_ERROR', error.message, info.componentStack); }
  render(): ReactNode {
    if (this.state.hasError) return <main className="app-shell"><section className="phone-frame"><div className="system-state"><strong>화면을 표시하지 못했습니다</strong><p>새로고침 후 다시 시도해 주세요.</p><button className="primary-button" onClick={() => location.reload()}>새로고침</button></div></section></main>;
    return this.props.children;
  }
}
